import React from 'react';

const Toggle = ({
  checked = false,
  onChange,
  label,
  helperText,
  disabled = false,
  className = '',
}) => {
  return (
    <div className={`flex items-start gap-3 ${className}`}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-colors
          focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2
          ${checked ? 'bg-purple-500' : 'bg-gray-300'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white transition-transform
            ${checked ? 'translate-x-6' : 'translate-x-1'}
          `}
        />
      </button>

      {(label || helperText) && (
        <div className="flex-1">
          {label && (
            <label className="block text-sm font-medium text-gray-900">
              {label}
            </label>
          )}
          {helperText && (
            <p className="mt-1 text-sm text-gray-500">
              {helperText}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Toggle;
